import React, { useMemo } from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormViewAsyn, formDetailsAsync, setviewForms } from "../../../app/customFormSlice";
import styles from "./characteristicCustomForm.module.scss";
import { Button } from "../../primary";
import { useParams } from "react-router-dom";
import { signLockAsync } from "../../../app/patientSlice";
import { signedLockedAccess } from "../../../utils";
import { Confirmation } from "../../secondary/Confirmation/confirmation";
import warning from "../../../static/images/icon-check-danger.png";
import { EditIcon } from "./CharacteristicCustomForm/editIcon";
import { ViewCustomForm } from "./CharacteristicCustomForm/viewCustomForm";
import { EditCustomForm } from "./CharacteristicCustomForm/editCustomForm";
import Loader from "../../../static/images/spinner.svg";
import { ReadOnlyBanner } from "../../secondary/ReadOnlyBanner/ReadOnlyBanner";

export function CharacteristicCustomForm({
  index,
  name,
  formId,
  queryParam,
  updateDone,
  selectedIndex,
  assessmentDetails,
  isCompleted,
  // historyCauseCompleted,
  characteristicTabsData,
  isReadOnly,
  hasPermission,
}) {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();

  const forms = useSelector((state) => state.forms.formDetailsData);
  const viewForm = useSelector((state) => state.forms.viewForms);
  const viewFormLoading = useSelector((state) => state.forms.viewFormLoading);
  const isFormLoading = useSelector((state) => state.forms.isFormLoading);
  const upDateStatus = useSelector((state) => state.forms.upDateSaveForm);

  const [editable, setEditable] = useState(false);
  const [formChangesConfirm, setFormChangesConfirm] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [clickCancel, setClickCancel] = useState(false);
  const [getForm, setGetForm] = useState(viewForm);
  const [customFormBuilder, setCustomFormBuilder] = useState([]);

  const formBuilder = useMemo(() => {
    if (!forms?.formBuilderInfo?.length) return [];
    return [...forms.formBuilderInfo].sort((a, b) => a.order - b.order);
  }, [forms?.formBuilderInfo]);

  useEffect(() => {
    if (!formBuilder.length || !viewForm?.formdata?.length) {
      setGetForm(viewForm);
      setCustomFormBuilder(formBuilder);
      return;
    }

    const sortedFormData = viewForm.formdata
      .map((item, idx) => {
        const formItem = formBuilder.find((f) => f.id === item.id);
        return { ...item, order: formItem?.order ?? idx };
      })
      .sort((a, b) => a.order - b.order);

    setGetForm({ formdata: sortedFormData });
    setCustomFormBuilder(formBuilder);
  }, [formBuilder, viewForm]);

  useEffect(() => {
    dispatch(setviewForms({}));
    dispatch(getFormViewAsyn({ id: formId, queryParam }));
    dispatch(formDetailsAsync(formId));
  }, [dispatch, formId, queryParam]);

  useEffect(() => {
    setEditable(!viewForm?.formdata?.length);
  }, [viewForm]);

  useEffect(() => {
    if (upDateStatus?.status === "success") {
      dispatch(signLockAsync({ patientId, assessmentId, type: "signlockactions" }));
    }
  }, [upDateStatus, patientId, assessmentId, dispatch]);

  useEffect(() => {
    if (editable && clickCancel) {
      setConfirmationModal(formChangesConfirm);
      if (!formChangesConfirm) {
        setClickCancel(false);
        setConfirmationModal(false);
        setEditable(false);
      }
    }
  }, [editable, clickCancel, formChangesConfirm]);

  const handleYes = () => {
    setGetForm(viewForm);
    setEditable(false);
    setClickCancel(false);
    setFormChangesConfirm(false);
    setConfirmationModal(false);
  };

  const handleNo = () => setConfirmationModal(false);

  return (
    <>
      {confirmationModal && (
        <Confirmation onClose={handleNo} title={" "}>
          <div className="text-center pr-5 pl-5">
            <p>
              <img src={warning} alt="warnning-icon" />
            </p>
            <p className="pb-3">All progress in this section will be lost. Are you sure want to cancel?</p>
            <div className="mb-2">
              <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${styles.yes_btn}` }} onClick={handleYes} />
              <Button id="closeId" value="No" classes={{ className: `btn ml-2 pb-2 pt-2 ${styles.no_btn}` }} onClick={handleNo} />
            </div>
          </div>
        </Confirmation>
      )}

      { isReadOnly && <ReadOnlyBanner /> }

      <EditIcon editable={editable} setEditable={setEditable} hasPermission={hasPermission} isSignedLocked={!signedLockedAccess(assessmentDetails?.assessmentStage)}  />

      {(viewFormLoading || isFormLoading) && (
        <div className="loader">
          <img src={Loader} alt="loading" />
        </div>
      )}

      {!isFormLoading && !viewFormLoading && (
        <div className={`col-md-12 ${styles.single_product_block}`}>
          <div className="row">
            <div className={`p-0 ${styles.patient_content}`}>
              {!editable ? (
                <ViewCustomForm getForm={getForm} customFormBuilder={customFormBuilder} />
              ) : (
                <EditCustomForm
                  index={index}
                  name={name}
                  formId={formId}
                  queryParam={queryParam}
                  updateDone={updateDone}
                  selectedIndex={selectedIndex}
                  assessmentDetails={assessmentDetails}
                  isCompleted={isCompleted}
                  customFormBuilder={customFormBuilder}
                  getForm={getForm}
                  setGetForm={setGetForm}
                  clickCancel={clickCancel}
                  handleYes={handleYes}
                  handleNo={handleNo}
                  // historyCauseCompleted={historyCauseCompleted}
                  characteristicTabsData={characteristicTabsData}
                  setFormChangesConfirm={setFormChangesConfirm}
                  setClickCancel={setClickCancel}
                  setCustomFormBuilder={setCustomFormBuilder}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
